export default "__VITE_ASSET__B89m5gq2__"